









































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import {BPopover,BIconBoxArrowRight,BIcon} from "bootstrap-vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    BPopover,
    NextPrevBtn,
    Footer,
    BIconBoxArrowRight,
    BIcon,
  },
})
export default class PosterTips extends Vue {
  protected nxtprevPosterTips = {
    BoolPrev: true ,
    BoolNext: true,
    PrevImage: "/thumbnail3.png",
    NextImage: "/thumbnail1.png",
    PrevLink: "/Affiche/Fondamentaux",
    NextLink: "/Affiche/EnPratique",
  };
}
